import { MenuItem, TextField } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { useController, useFormContext } from 'react-hook-form';
import { useQueryContractsByBrands } from 'shared/queries';
import { useMemo, useState } from 'react';

interface ContractDropdownFieldProps {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  brands: Array<string>;
  customer: string;
}
export function ContractdropdownField({ name, brands, customer }: ContractDropdownFieldProps) {
  const { setValue } = useFormContext();
  const { field } = useController({
    name,
    defaultValue: '',
  });
  const { contracts } = useQueryContractsByBrands({ brands, customer });
  const [contract, setContract] = useState<string | undefined>(undefined);

  const contractOptions = useMemo(
    () =>
      (contracts || []).map(contract => ({
        label: `${contract.brand} ${contract.billToCode} ${contract.originalDocumentName}`,
        value: contract,
      })),
    [contracts]
  );

  const handleDelete = () => {
    setValue(name, undefined);
    setContract('');
  };

  return (
    <TextField
      {...field}
      variant='outlined'
      id={name}
      label='Copy info from contract'
      select
      value={contract || ''}
      fullWidth
      InputProps={{ endAdornment: <ClearIcon sx={{ marginRight: '10px' }} fontSize='small' onClick={handleDelete} /> }}
      onChange={event => {
        setContract(event.target.value);
      }}
    >
      {contractOptions.map(option => (
        <MenuItem
          key={option.value.id}
          value={option.value.id}
          onClick={() => {
            setValue(name, option.value);
          }}
        >
          {option.label}
        </MenuItem>
      ))}
    </TextField>
  );
}
